/* AZFindings product page scripts */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var productData = JSON.parse(document.getElementById('ProductJson').textContent);
  var form = root.querySelector('form[data-product-form]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = root.querySelector('[data-product-price]');
  var comparePriceEl = root.querySelector('[data-product-compare-price]');
  var atcBtn = form.querySelector('[data-atc-button]');
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var AZ_COLOR_MAP = {'Schwarz':'#1c1c1c','Weiß':'#f5f5f0','Weiss':'#f5f5f0','Blau':'#2c4a7c','Rot':'#b23a3a','Grün':'#3a7c4e','Grau':'#8a8a8a','Beige':'#d8c7a8','Rosa':'#e8a9c0','Gold':'#c9a15a','Silber':'#c0c0c0','Braun':'#6b4a34','Gelb':'#e0c341','Lila':'#7c5ba6','Orange':'#d9772e','Marine':'#1c2b45','Navy':'#1c2b45','Creme':'#f0e6d2','Multicolor':'linear-gradient(135deg,#e8a9c0,#2c4a7c,#e0c341)'}; root.querySelectorAll('.option-value__swatch-dot').forEach(function (dot) { var nm = dot.getAttribute('data-swatch-name'); var col = AZ_COLOR_MAP[nm]; if (col) dot.style.setProperty('--swatch-bg', col); });

  /* Track for "recently viewed" */
  if (window.AZTrackProduct) window.AZTrackProduct(productData.handle);

  /* ---------- Gallery ---------- */
  var mainStage = root.querySelector('[data-gallery-main]');
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-thumb]');
    if (!thumb || !mainStage) return;
    var tpl = document.getElementById('media-' + thumb.getAttribute('data-media-thumb'));
    if (tpl) {
      mainStage.innerHTML = tpl.innerHTML;
      root.querySelectorAll('[data-media-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
      var v = mainStage.querySelector('video');
      if (v) v.play().catch(function () {});
    }
  });

  /* ---------- Variant selection ---------- */
  function currentOptions() {
        return Array.prototype.map.call(form.querySelectorAll('.option-values'), function (g) { var b = g.querySelector('[aria-pressed="true"]'); return b ? b.getAttribute('data-value') : null; });
  }
  function findVariant(options) {
    return productData.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    });
  }
  function updateVariant() {
    var variant = findVariant(currentOptions());
    var strings = (window.AZ && window.AZ.strings) || {};
    if (!variant) {
      atcBtn.disabled = true;
      atcBtn.textContent = strings.unavailable || 'Nicht verfügbar';
      return;
    }
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = window.AZFormatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.hidden = false;
        comparePriceEl.textContent = window.AZFormatMoney(variant.compare_at_price);
      } else { comparePriceEl.hidden = true; }
    }
    atcBtn.disabled = !variant.available;
    atcBtn.textContent = variant.available ? (strings.addToCart || 'In den Warenkorb') : (strings.soldOut || 'Ausverkauft');
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    if (variant.featured_media && variant.featured_media.id) {
      var thumb = root.querySelector('[data-media-thumb="' + variant.featured_media.id + '"]');
      if (thumb) thumb.click();
    }
    if (stickyBar) {
      var sp = stickyBar.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = window.AZFormatMoney(variant.price);
    }
  }
form.querySelectorAll('.option-values').forEach(function (group) { group.addEventListener('click', function (e) { var btn = e.target.closest('[data-option-value]'); if (!btn || btn.classList.contains('is-unavailable') || btn.getAttribute('aria-pressed') === 'true') return; Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (b) { b.setAttribute('aria-pressed', 'false'); }); btn.setAttribute('aria-pressed', 'true'); var og = btn.closest('.option-group'); var cur = og ? og.querySelector('.option-value-current') : null; if (cur) cur.textContent = btn.getAttribute('data-value'); updateVariant(); updateOptionAvailability(); }); }); function updateOptionAvailability() { var current = currentOptions(); form.querySelectorAll('.option-values').forEach(function (group, idx) { Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (btn) { var test = current.slice(); test[idx] = btn.getAttribute('data-value'); var ok = productData.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; }); }); btn.classList.toggle('is-unavailable', !ok); }); }); } updateOptionAvailability();

  /* ---------- Sticky mobile ATC ---------- */
  if (stickyBar && atcBtn) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(atcBtn);
    stickyBar.querySelector('[data-sticky-submit]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  /* ---------- Recently viewed section ---------- */
  var rvContainer = document.querySelector('[data-recently-viewed]');
  if (rvContainer && window.AZRenderRecentlyViewed) {
    window.AZRenderRecentlyViewed(rvContainer, productData.handle, 4);
  }
})();
